import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './context'
import UiSpinner from './ui_spinner';
import UiInput3 from './ui_input3';
import moment from 'moment';

const EditorBrand = () => {

    let navigate = useNavigate()

    const {
        neonUser, setBrandList, brandList,
        hh, ww,
        fetchDataV2,
    } = useContext(AppContext)

    const [displayList, setDislpayList] = useState([])
    const [search, setSearch] = useState("")
    const [loading, setLoading] = useState(true)
    const [sortMode, setSortMode] = useState(1)

    const sortModeHandler = () => {
        if (sortMode == 1) {
            setSortMode(sortMode + 1)
            setDislpayList(displayList.sort((a, b) => b.brand.toLowerCase().localeCompare(a.brand.toLowerCase())))
            return
        }
        if (sortMode >= 2) {
            setSortMode(1)
            setDislpayList(displayList.sort((a, b) => a.brand.toLowerCase().localeCompare(b.brand.toLowerCase())))
            return
        }
    }

    const filterList = () => {
        let list = [...brandList]
        list = list.filter(x => x.brand.toLowerCase().includes(search.toLowerCase()))
        setDislpayList(list)
    }

    const getEditorBrands = async () => {
        setLoading(true)

        let query1 = neonUser.user.all_entities ?
            "GET_EDITOR_BRANDS" :
            "GET_EDITOR_BRANDS_ENTITY_LIST",
            params1 = neonUser.user.all_entities ?
                [neonUser.user.agency_id] :
                [neonUser.entity_id_list]

        try {
            let brands = await fetchDataV2(query1, params1, "/neon-query-v2")
            setBrandList(brands)
        }
        catch (err) {
            return
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setDislpayList([...brandList])
    }, [brandList])

    useEffect(() => {
        filterList()
    }, [search])

    useEffect(() => {
        if (neonUser.user_id) getEditorBrands()
    }, [neonUser])

    if (loading) return (
        <div className="d-flex justify-content-center" style={{ height: hh - 80 }}>
            <UiSpinner />
        </div>
    )

    return (
        <div style={{ maxWidth: 1600 }}>
            <div className={" d-flex flex-column gap-3 " + (ww < 400 ? "px-1 pt-4" : "p-4")}>
                <div className={`d-flex justify-content-end`}>
                    <div className={"d-flex gap-2 " + (ww < 450 ? "flex-column w-100" : "")}>
                        <div>
                            <UiInput3 value={search} setSearch={setSearch} />
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="brand-table">
                        <thead>
                            <tr>
                                <th onClick={sortModeHandler}>
                                    <div className='d-flex gap-1 justify-content-between' style={{ cursor: "pointer" }}>
                                        <span></span>
                                        <span className='text-truncate align-self-center'>Name</span>
                                        {sortMode == 1 ?
                                            <i className="bi bi-caret-up-fill align-self-center"></i>
                                            :
                                            <i className="bi bi-caret-down-fill align-self-center"></i>
                                        }
                                    </div>
                                </th>
                                <th className="middle-row-th">Account Type</th>
                                <th className="middle-row-th">Start Date</th>
                                <th className="middle-row-th">Status</th>
                                <th className="middle-row-th">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayList && displayList.map(x => (
                                <tr key={x.id} onClick={() => { navigate('/brand/' + x.id) }} title={x.brand}>
                                    <td style={{ cursor: "pointer", maxWidth: 220 }} className="text-truncate">{x.brand}</td>
                                    <td style={{ cursor: "pointer" }} className="middle-row-td">{x.ads_management ? x.ads_management.join("/") : ""}</td>
                                    <td style={{ cursor: "pointer" }} className="middle-row-td">{moment(x.created).format("MMM, D YYYY")}</td>
                                    {x["active?"] ?
                                        <td className="text-success middle-row-td">Active</td>
                                        :
                                        <td className="middle-row-td text-danger">Inactive</td>
                                    }
                                    <td className="middle-row-td">
                                        <div className="d-flex gap-3 justify-content-center">
                                            <div title="view" onClick={() => { }} style={{ width: 20, height: 20, cursor: "pointer" }}>
                                                <img src={"/src/view.png"} className="w-100" />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {displayList.length == 0 && (
                                <tr className="text-center">
                                    <td colSpan={5} className='poppins text-secondary'>Nothing to show...</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default EditorBrand